import { connect } from 'react-redux'
import { sagaActions } from 'store/sagas'
import userGroupUsersSelector from './userGroupUsersSelector'
import UserGroupUsers from './UserGroupUsers'

export default connect(
  userGroupUsersSelector,
  {
    fetchUserGroupUsers: sagaActions.fetchUserGroupUsers
  }
)(UserGroupUsers)
